export const indexBy = (array, indexByFunction) =>
    array.reduce(
        (result, obj) => ({
            ...result,
            [indexByFunction(obj)]: obj,
        }),
        {}
    );
